import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { addMessage } from "~/features/toasts/redux/actions";
import { redirectToUrl } from "~/utils/url/urlUtils";
import { SAVED_CONFIGS_PAGE } from "~/utils/url/staticUrls";
import { saveConfiguratorV2 } from "../data/configuratorV2Api";
import { configuratorMutationKey } from "../data/configuratorConfigurationQuery";
import type { ConfiguratorConfiguration } from "../contract/configuration";

export const useConfiguratorSave = (configuration: ConfiguratorConfiguration, allStepsSatisfied: boolean) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const mutation = useMutation({
    mutationKey: configuratorMutationKey(configuration.productCode),
    mutationFn: saveConfiguratorV2,
    onSuccess: () => {
      dispatch(addMessage("info", t("page.linear.saveConfig.result.success")));
      redirectToUrl(SAVED_CONFIGS_PAGE);
    },
  });

  const saveConfiguration = useCallback(
    (name: string) => mutation.mutateAsync({ configId: configuration.configId, name, allStepsSatisfied }),
    [allStepsSatisfied, configuration.configId, mutation],
  );

  return {
    error: mutation.error,
    isSaving: mutation.isPending,
    saveConfiguration,
  };
};
